/**
 * Build a wa.me URL for contacting a seller about a product.
 * Auto-adds Costa Rica country code (+506) for 8-digit local numbers.
 */
export function buildWhatsappUrl(rawPhone: string, message: string): string {
  const digits = (rawPhone || "").replace(/\D/g, "");
  if (!digits) return "";
  const phone = digits.length === 8 ? `506${digits}` : digits;
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}

export function buildProductInquiryMessage(productTitle: string, productUrl?: string): string {
  const base = `Hola, vi este producto en TicoMarket y me gustaría más información: ${productTitle}`;
  return productUrl ? `${base}\n${productUrl}` : base;
}
